import { AbwKontoInhaberModel } from '../../../../../shared/models/view/AbwKontoInhaber';
import { BankdatenModel } from '../../../../../shared/models/view/Bankdaten';
import { AdresseModel } from '../../../../../shared/models/view/Adresse';
import { AppUtils } from '../../../../../shared/utils/index';

/**
 * This model represents the calculator input data.
 */
export class AppCalculatorModel extends BankdatenModel {
	private bankleitzahl: string;
	private kontonummer: string;
	constructor() {
		super();
		this.AbwKontoInhaber = new AbwKontoInhaberModel();
		this.AbwKontoInhaber.Adresse = new AdresseModel();
	}

	get Kontonummer(): string {
		return this.kontonummer;
	}

	set Kontonummer(value: string) {
		this.kontonummer = value;
	}

	get Bankleitzahl(): string {
		return this.bankleitzahl;
	}

	set Bankleitzahl(value: string) {
		this.bankleitzahl = value;
	}

	get Valid(): boolean {
		return !!this.Iban;
	}

	/**
	 * Creates a new OhcCalculatorModel object and copies the values from the provided data object (or other calculator model) to the created OhcCalculatorModel.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): AppCalculatorModel {
		return AppUtils.Helper.createFromMap(dataObject, AppCalculatorModel, (key: string, value: any) => {
			if (key.toLowerCase() === 'abwkontoinhaber') {
				return AbwKontoInhaberModel.createFromObject(value);
			} else {
				return value;
			}
		});
	}
}
